import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            gap: ['xsmall-1.base', 'xsmall-1.sm', 'xsmall-1.md', 'xsmall-1.lg'],
            justifyContent: {base: 'center', xl: 'flex-start'},
            p: ['xsmall-1.base', 'xsmall-1.sm', 'xsmall-1.md', 'small.lg'],
        },
        text: {textStyle: 'head-xsmall', color: 'foreground.neutral.default', fontWeight: 'normal'},
        time: {
            boxSize: remCalc(78),
            backgroundColor: 'background.base.under',
            borderRadius: 'large-1',
            textStyle: 'head-large',
            color: 'foreground.neutral.default',
            fontWeight: 'bold',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            _after: {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: 0,
                width: '100%',
                height: remCalc(2),
                backgroundColor: 'background.default',
                transform: 'translateY(-50%)',
                zIndex: 0,
            },
        },
        timeNumber: {
            zIndex: 1,
            textStyle: 'head-large',
            fontWeight: 'bold',
        },
        counterBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.md', 'xxsmall-1.lg'],
        },
        v2Container: {
            position: 'relative',
            isolation: 'isolate',
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            px: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.md', 'xxsmall-1.lg'],
            py: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],

            _before: {
                content: '""',
                position: 'absolute',
                inset: 0,
                zIndex: -1,
                border: 'small',
                borderColor: 'border.neutral.overlay',
                borderStyle: 'solid',
                borderRadius: 'large-1',
                bg: 'background.base.overlay',
                backdropFilter: 'blur(5px)',
            },
        },
        v2CounterBox: {
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
        },
        v2Time: {
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            w: {base: remCalc(55), md: remCalc(76)},
            h: 'auto',
            bg: 'transparent',
            color: 'foreground.neutral.inverse',
            _after: {
                content: '""',
                display: 'none',
            },
        },
        v2TimeNumber: {
            fontWeight: 'light',
            color: 'foreground.neutral.inverse',
            fontFamily: 'heading',
        },
        v2Text: {
            fontWeight: 'light',
            textStyle: 'body-small',
            color: 'foreground.neutral.inverse',
        },
        v2Divider: {
            color: 'border.neutral.highlight',
        },
    },
    variants: {
        black: {
            text: {color: 'foreground.neutral.inverse'},
            v2Text: {},
            v2Time: {},
            v2TimeNumber: {},
        },
    },
    parts: [
        'container',
        'text',
        'time',
        'timeNumber',
        'counterBox',
        'v2Container',
        'v2CounterBox',
        'v2Time',
        'v2TimeNumber',
        'v2Text',
        'v2Divider',
    ],
}
